import type { EventExtra } from '@cocoonspace/sdk-js/types/eventExtra'
import type { Extra } from '@cocoonspace/sdk-js/types/extra'
import Markdown from 'react-markdown'
import { buttonVariants } from '@cocoonspace/ui/components/button'
import { cn } from '@cocoonspace/ui/lib/utils'
import { useLingui } from '@lingui/react/macro'
import { LocalizedLink as Link } from '~/components/localized-link'

export const ExtraComposition = ({
	extra,
	className,
}: {
	extra: Pick<Extra, 'id' | 'composition'>
	className?: string
}) => {
	const { t } = useLingui()

	return (
		<div
			className={cn(
				'prose prose-p:m-0 prose-ul:m-0 prose-li:my-0 prose-ul:leading-tight marker:text-primary/50 text-sm',
				className,
			)}
		>
			<div className='font-semibold'>{t`Cet extra comprend :`}</div>
			<Markdown>{extra.composition}</Markdown>
		</div>
	)
}

export const ExtraDelivery = ({
	extra,
	className,
}: {
	extra: Pick<
		EventExtra,
		'id' | 'delivery_hours' | 'delivery_description' | 'external_link'
	>
	className?: string
}) => {
	const { t } = useLingui()

	return (
		<div className={cn('flex flex-col items-start gap-2', className)}>
			<div>
				<div className='font-semibold'>{t`Créneau de livraison :`}</div>
				{extra.delivery_description && <div>{extra.delivery_description}</div>}
				<div>{extra.delivery_hours?.slice(0, 2).join(' - ')}</div>
			</div>

			{!!extra.external_link && (
				<Link
					className={buttonVariants({ size: 'sm', variant: 'link' })}
					href={extra.external_link.href || ''}
					target='_blank'
				>
					{extra.external_link.label}
				</Link>
			)}
		</div>
	)
}

export const CompositionAndDelivery = ({
	extra,
	className,
}: {
	extra: Pick<EventExtra, 'id' | 'delivery_hours'>
	className?: string
}) => (
	<div
		className={cn(
			'flex flex-col gap-4 p-4 text-sm max-sm:divide-y sm:flex-row',
			className,
		)}
	>
		<ExtraComposition
			className='flex-1'
			extra={extra}
		/>

		<ExtraDelivery
			className='flex-1'
			extra={extra}
		/>
	</div>
)
